import { render, staticRenderFns } from "./selfAdaption.vue?vue&type=template&id=0c4cb5a3&scoped=true"
import script from "./selfAdaption.vue?vue&type=script&lang=js"
export * from "./selfAdaption.vue?vue&type=script&lang=js"
import style0 from "./selfAdaption.vue?vue&type=style&index=0&id=0c4cb5a3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4cb5a3",
  null
  
)

export default component.exports